<body>
    <div class="main-wrapper">
        <div class="main-content">
            <header>

                <div class="head-line">

                    <p>Template Listing</p>


                </div>
                <div class="user-wrapper">
                    <p>{{storedData.agencyRefId.agencyName}}</p>

                    <div>
                        <img class="log1"
                            [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/../../assets/images/user1.jpeg'">
                    </div>
                </div>
            </header>




            <div class="header3">

                <label>
                    <i (click)="viewProgress()" style="color: rgb(122, 122, 253);font-size: 14px;cursor: pointer;">
                        Click here to view the send progress</i></label>


                <div>

                    <button class="btn btn-outline-success" (click)="downloadTemplate()"> Download Excel:
                            <img src="../../assets/images/downloadExcel.png" style="width: 20px;height: 20px;" title="Download Excel">
                    </button>
                   
                    
                </div>

                <div class="dropdown-container">
                    <label for="rows">Rows</label>
                    <div class="middle-b"></div>
                    <select id="rows" (change)="onTableSizeChange($event)">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="1000">1000</option>

                    </select>
                </div>


                <!-- 
                <div class="dropdown-container">
                    <label for="rows">Initiated By</label>
                    <div class="middle-b"></div>
                    <select id="rows"  (change)="onInitiatedByChange($event)"   style="    width: 196px;" >
                        <option *ngFor="let item of staffDetails" [value]="item._id">{{item.name}}</option>
                        
                    </select>
                </div> -->




                <div class="fill-sea">
                    <div class="search-m">
                        <input type="text" id="searchQueryInput2" placeholder="Search here..."
                            [(ngModel)]="searchQuery" (input)="listTemplates()">
                        <button type="submit" id="searchQuerySubmit"><svg viewBox="0 0 24 24"
                                style="width: 24px; height: 24px;">
                                <path fill="#666666"
                                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z">
                                </path>
                            </svg>
                        </button>
                    </div>

                </div>


            </div>
            <!-- <div class="dropdown-container">
                <ng-multiselect-dropdown 
                class="dropdown-two" 
                [settings]="dropdownSettings" 
                [data]="cases"  
                [ngModelOptions]="{standalone: true}" 
                [(ngModel)]="selectedStatuses"  
                (onSelect)="PushStatus()"
                (onDeSelect)="PushStatus()">
            </ng-multiselect-dropdown>
    </div> -->
            <main class="main-2">

                <div class="container">
                    <div class="projects">


                        <div class="two-screen">

                            <div class="mainside2">
                                <table class="table-main">
                                    <thead>


                                        <tr>
                                            <th>Template Name</th>
                                            <th>Subject</th>
                                            <!-- <th>Download Excel</th> -->
                                            <th>Bulk Email</th>
                                            <th></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr    *ngFor="let eachCase of templates; let i = index;  " (dblclick)="detail(eachCase); $event.stopPropagation()">
                                        <!-- <tr> -->

                                            <td>
                                                <p class="name-one" (click)="copyText(eachCase.templateName)" title="Click to copy">{{ eachCase.templateName }}</p>

                                            </td>
                                            <td>
                                                <p class="name-one" (click)="copyText(eachCase.subject)" title="Click to copy">{{ eachCase.subject }}</p>
                                            </td>
                                            <!-- <td>
                                                <img src="../../assets/images/downloadExcel.png" style="width: 20px;height: 20px;" title="Download Excel">
                                            </td> -->
                                            <td>
                                               <button class="btn btn-outline-success" (click)="openExcelUploadSwal(eachCase)">
                                                <i class="bi bi-file-earmark-excel me-1"></i> Upload Excel
                                                </button>
                                            </td>
                                            <td class="right-align" style="width:8%">
                                                <div class="pop-over" style="cursor: pointer;">
                                                    <img src="../../assets/images/eye-open (1).png"
                                                        style="filter: invert(1) brightness(0);" (click)="detail(eachCase)">&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <img src="../../assets/images/Delete.png"
                                                        style="filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(356deg) brightness(95%) contrast(108%);"
                                                         (click)="deleteItem(eachCase,i)">

                                                </div>
                                            </td>
                                        </tr>







                                    </tbody>


                                </table>
                                <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="onTableDataChange($event)">
                                    </pagination-controls>
                                <!-- <span style="    margin-left: 76px;">{{currentCount }}  Of  {{ total}}</span> -->
                            </div>



                            <!--float button-->
                            <a class="float7" (click)="openModal()">
                                 ⚙️ Settings
                            </a>
                             <!--float button-->
                            <a class="float6" (click)="route()">
                                <img src="../../assets/images/plus.png"> Add New
                            </a>

                            <!-- </div> -->

                        </div>

                    </div>

                </div>


            </main>

        </div>
    </div>

    <div class="footer-section2">

        <img src="../../assets/images/accruon-footer (2).png">
    </div>

</body>


<!-- whatsapp-config-modal.component.html -->
<div class="wa-backdrop" *ngIf="open">
  <div class="wa-modal" role="dialog" aria-modal="true" aria-labelledby="waModalTitle">
    <header class="wa-modal__header">
      <h2 id="waModalTitle">WhatsApp Configuration</h2>
      <button class="wa-close" (click)="close()" aria-label="Close">&times;</button>
    </header>

    <form [formGroup]="settingsForm" (ngSubmit)="save()" class="wa-modal__body" novalidate>
      <div class="wa-grid">

          <label class="wa-field">
          <span class="wa-label">From</span>
          <input type="email" formControlName="from" />
          <!-- <div class="wa-help">International format (E.164) recommended.</div> -->
        </label>

       
        <label class="wa-field">
          <span class="wa-label">Host 
            <!-- <small class="required">*</small> -->
        </span>
          <input type="text" formControlName="host"  />
          <!-- <div class="wa-error" *ngIf="control('host').invalid && control('host').touched">
            Valid host URL is required.
          </div> -->
        </label>

      

        <label class="wa-field">
          <span class="wa-label">Port</span>
          <input type="text" formControlName="port" placeholder="Port number" />
        </label>

       

        <label class="wa-field">
          <span class="wa-label">Email Username</span>
          <input type="email" formControlName="userName"/>
        </label>

        <label class="wa-field">
          <span class="wa-label">App Password</span>
          <input type="password" formControlName="appPassword" />
        </label>

      </div>

      <footer class="wa-modal__footer">
        <div class="wa-left">
          <small class="wa-note">All changes will be saved securely.</small>
        </div>
        <div class="wa-actions">
          <button type="button" class="btn btn-ghost" (click)="close()">Cancel</button>
          <button type="submit" style="cursor: pointer;" class="btn btn-primary">Save & Apply</button>
        </div>
      </footer>
    </form>
  </div>
</div>



